import { Link } from "react-router-dom";
import Disclaimer from "../../components/Disclaimer/Disclaimer";
import Layout from "../../components/Layout/Layout";

const About = () => {
  return (
    <Layout>
      <section className="max-w-3xl mx-auto px-6 py-16 w-full">
        <p className="text-sun font-semibold uppercase tracking-wide text-sm">
          A project of Earthbound Martian
        </p>
        <h1 className="text-5xl font-bold text-alt-blk mt-3">About LotCamp</h1>
        <p className="text-xl text-alt-blk/80 mt-6 leading-relaxed">
          Sleep at the show. This is a practical, free tool for outdoor music
          festivals — death metal, black metal, pagan gatherings, goth open
          airs, folk rites — with dates, a pin, and whether the lot takes a van.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">What v1 is</h2>
        <p className="leading-relaxed mb-4">
          A map of lots in the US and Europe, a modest curated list, and a
          calendar of seasons. Useful first. Promotional second. Wacken is on
          the list because the lot is the culture — not because you have to fly
          to Schleswig-Holstein. Inkcarceration and Free Spirit are here for
          the same reason.
        </p>
        <p className="leading-relaxed">
          It is not a ticket shop, a lineup wiki, or Coachella. Faire camping
          lives at{" "}
          <a
            href="https://rencamp.earthboundmartian.com"
            className="text-turquoise hover:text-mars"
          >
            RenCamp
          </a>
          . Dark-sky overnights live at{" "}
          <a
            href="https://darkskies.earthboundmartian.com"
            className="text-turquoise hover:text-mars"
          >
            Darkskies
          </a>
          .
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Data</h2>
        <Disclaimer />
        <p className="leading-relaxed mt-4">
          Dates are taken from organizer calendars for 2026 where we could
          confirm them. When a run has closed, we project the typical season so
          you can still plan the next year. Place search uses{" "}
          <a
            className="text-turquoise hover:text-mars"
            href="https://photon.komoot.io"
            target="_blank"
            rel="noreferrer"
          >
            Photon
          </a>{" "}
          (OpenStreetMap).
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Camping notes</h2>
        <p className="leading-relaxed">
          “On the lot” means the event sells or hosts camping — tent city, RV
          field, or official campground. “Nearby” means a realistic overnight
          within a short drive. “Hotels / day trip” means the infield is not
          the plan. Pins are not a reservation. Rules change.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Earthbound Martian</h2>
        <p className="leading-relaxed mb-6">
          LotCamp is built for the same people who want comfortable multi-night
          stays next to a stage. If that is your kind of work, the Landships
          are for that kind of work. No hard sell — just a door back to the shop.
        </p>
        <div className="flex flex-wrap gap-3">
          <a
            href="https://earthboundmartian.com"
            className="inline-block bg-mars hover:bg-sunset text-white px-8 py-4 rounded-2xl font-semibold"
          >
            Visit Earthbound Martian
          </a>
          <Link
            to="/contact"
            className="inline-block border border-alt-blk px-8 py-4 rounded-2xl font-semibold hover:bg-alt-blk hover:text-white transition-colors"
          >
            Contact
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default About;
